import { gql } from '@apollo/client';

export const UPDATE_ME_MUTATION = gql`
  mutation UpdateMe($input: UpdateUserInput!) {
    updateMe(input: $input) {
      id
      username
      email
      firstName
      lastName
      imageUrl
    }
  }
`;

export const CHANGE_EMAIL_MUTATION = gql`
  mutation ChangeEmail($email: String!, $password: String!) {
    changeEmail(email: $email, password: $password)
  }
`;

export const CHANGE_USERNAME_MUTATION = gql`
  mutation ChangeUsername($username: String!, $password: String!) {
    changeUsername(username: $username, password: $password)
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($currentPassword: String!, $newPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`;

export const DELETE_ACCOUNT_MUTATION = gql`
  mutation DeleteAccount($password: String!) {
    deleteAccount(password: $password)
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation AuthLogout {
    authLogout
  }
`;

export const GET_SIGNED_UPLOAD_URL_QUERY = gql`
  query GetSignedUploadUrl(
    $uploadType: SignedUploadType!
    $fileName: String!
    $fileType: String!
    $fileSize: Int!
  ) {
    getSignedUploadUrl(
      uploadType: $uploadType
      fileName: $fileName
      fileType: $fileType
      fileSize: $fileSize
    ) {
      signedUploadUrl
      key
      url
    }
  }
`;

// Type definitions
export type UpdateMeMutationData = {
  updateMe: {
    id: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    imageUrl: string;
  };
};

export type ChangeEmailMutationData = {
  changeEmail: boolean;
};

export type ChangeUsernameMutationData = {
  changeUsername: boolean;
};

export type ChangePasswordMutationData = {
  changePassword: boolean;
};

export type DeleteAccountMutationData = {
  deleteAccount: boolean;
};

export type LogoutMutationData = {
  authLogout: boolean;
};

export type GetSignedUploadUrlQueryData = {
  getSignedUploadUrl: {
    signedUploadUrl: string;
    key: string;
    url: string;
  };
};
